import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../services/api';

const AuthContext = createContext(null);

const LS_TOKEN = 'auth-token';

export function AuthProvider({ children }) {
  const [token,   setToken]   = useState(() => localStorage.getItem(LS_TOKEN));
  const [user,    setUser]    = useState(null);
  const [loading, setLoading] = useState(true); // true durante o check inicial do /me

  // Na montagem: se há token, valida com /api/auth/me e hidrata o usuário
  useEffect(() => {
    if (!token) {
      setLoading(false);
      return;
    }
    api.get('/api/auth/me')
      .then(res => setUser(res.data))
      .catch(() => {
        // Token expirado ou inválido — limpa estado
        localStorage.removeItem(LS_TOKEN);
        setToken(null);
      })
      .finally(() => setLoading(false));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const login = useCallback(async (email, password) => {
    const res = await api.post('/api/auth/login', { email, password });
    const { token: newToken, user: newUser } = res.data;
    localStorage.setItem(LS_TOKEN, newToken);
    setToken(newToken);
    setUser(newUser);
    return newUser;
  }, []);

  const logout = useCallback(async () => {
    try {
      await api.post('/api/auth/logout');
    } catch {
      // Ignora erro — limpa estado de qualquer forma
    }
    localStorage.removeItem(LS_TOKEN);
    setToken(null);
    setUser(null);
  }, []);

  /**
   * Verifica se o usuário logado tem um dos roles informados.
   * hasRole('moderador') ou hasRole(['moderador', 'gestor_municipal'])
   */
  const hasRole = useCallback((roles) => {
    if (!user) return false;
    const list = Array.isArray(roles) ? roles : [roles];
    return list.includes(user.role);
  }, [user]);

  const value = { user, token, loading, login, logout, hasRole };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth deve ser usado dentro de AuthProvider');
  return ctx;
}

export default AuthContext;
